<template>
    <step-wrapper>
        <step-heading class="flex items-center justify-between">
            {{ $t('BODY') }}
            <button
                class="
                  rounded-[4px] text-[14px] font-normal uppercase underline focus-outline-only

                  disabled:opacity-40
                "
                :disabled="loadedFromRecipe"
                @click="resetBodyStep"
            >
                {{ $t('CLEAR') }}
            </button>
        </step-heading>

        <template v-if="activeProductType === ProductType.RING">
            <div class="flex w-full justify-between">
                <step-section-heading>
                    {{ $t('RING_TYPE') }}
                </step-section-heading>
            </div>

            <style-buttons class="mb-[48px]" />

            <div class="flex justify-between">
                <step-section-heading>
                    {{ $t('COLOR') }}
                </step-section-heading>
                <div class="font-caption text-[16px] uppercase">
                    {{ selectedColor }}
                </div>
            </div>

            <color-swatches class="mb-[48px]" :selected-color="selectedColor" />

            <div class="mb-[48px]">
                <div class="flex w-full justify-between">
                    <step-section-heading>
                        {{ $t('RING_SIZE') }}
                    </step-section-heading>
                    <a
                        href="https://ridge.com/pages/ridge-ring-size-chart"
                        target="_blank"
                        class="mb-[16px] flex items-center text-[12px] font-normal underline"
                    >
                        <span class="mr-[4px]">
                            {{ $t('FIND_YOUR_SIZE') }}
                        </span>
                        <measure-icon class="inline-block size-[18px]" />
                    </a>
                </div>
                <div class="mb-[24px] flex gap-[12px]">
                    <drop-down
                        :options="sizeOptionsForDropdown"
                        :placeholder="$t('SELECT_SIZE')"
                        @select="selectSize"
                        :selected-value="selectedSize"
                    />
                </div>
            </div>
        </template>

        <template v-else>
            <div class="flex w-full justify-between">
                <step-section-heading>
                    {{ $t('COLOR') }}
                </step-section-heading>
                <div class="font-caption text-[16px] uppercase">
                    {{ selectedColor }}
                </div>
            </div>

            <color-swatches class="mb-[48px]" :selected-color="selectedColor" />

            <div v-if="activeProductType === ProductType.WALLET" class="mb-[48px]">
                <div class="flex w-full justify-between">
                    <step-section-heading>
                        {{ $t('WALLET_STYLE') }}
                    </step-section-heading>
                </div>

                <style-buttons />
            </div>
        </template>
    </step-wrapper>
</template>

<script>
    import StepHeading from '../UI/headings/StepHeading.vue';
    import StepSectionHeading from '../UI/headings/StepSectionHeading.vue';
    import ColorSwatches from '../UI/colors/ColorSwatches.vue';
    import StyleButtons from '../UI/buttons/StyleButtons.vue';
    import StepWrapper from '../wrappers/StepWrapper.vue';
    import DropDown from '../UI/dropdowns/DropDown.vue';
    import allStores from '../../stores/all';
    import { ProductType } from '../../constants';
    import MeasureIcon from '../icons/MeasureIcon.vue';

    export default {
        mixins: [allStores],

        name: 'BodyStep',

        components: {
            StepHeading,
            StepSectionHeading,
            ColorSwatches,
            StyleButtons,
            StepWrapper,
            DropDown,
            MeasureIcon,
        },

        data() {
            return {
                ProductType,
            };
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            loadedFromRecipe() {
                return this.customizerStore.loadedFromRecipe;
            },

            availablePersonalizationTypes() {
                return this.customizerStore.availablePersonalizationTypes;
            },

            activeProductType() {
                return this.customizerStore.activeProductType;
            },

            availablePersonalizationColors() {
                return this.customizerStore.availablePersonalizationColors;
            },

            selectedColor() {
                return this.customizerStore.availablePersonalizationColors.find((color) => color.selected)?.text;
            },

            availablePersonalizationSizes() {
                const sizes = this.customizerStore.availablePersonalizationSizes ?? [];
                return [...sizes]
                    .sort((a, b) => Number(a.value.replace('Ring', '')) - Number(b.value.replace('Ring', '')));
            },

            sizeOptionsForDropdown() {
                return this.availablePersonalizationSizes.map((size) => ({
                    label: size.value.replace('Ring', ''),
                    value: size.value,
                    option: size,
                }));
            },

            selectedSize() {
                return this.availablePersonalizationSizes.find((x) => x.selected)?.value;
            },
        },

        methods: {
            resetBodyStep() {
                this.customizerStore.resetBodyStep();
            },

            selectSize(value) {
                const option = this.sizeOptionsForDropdown.find((x) => x.value === value);

                if (option) {
                    if (!this.viewController.updateSimilarComponent('ProductColor', option.value, 'Item Size')) {
                        this.viewController.updateComponent('ProductColor', option.option.selectable.safeSelection);
                    }
                }

                // // Manually find a component with the same color and size
                // const colors = this.viewController?.findPlacement('ProductColor');
                // const selected = this.viewController.selectedAtPlacement('ProductColor');
                // const selectedColor = selected.description.find((x) => x.definition === 'Item Color');

                // for (const color of colors.components) {
                //     if (color.description.some((x) => x.code === value)) {
                //         if (color.description.some((x) => x.name === selectedColor.name)) {
                //             if (this.viewController.updateComponent('ProductColor', color.code)) {
                //                 return;
                //             }
                //         }
                //     }
                // }

                // // Keep safeSelection logic from RingSizeButtons
                // const size = this.availablePersonalizationSizes.find((s) => s.value === value);
                // if (size?.safeSelection) {
                //     this.viewController.updateComponent('ProductColor', size.safeSelection);
                // }
            },
        },
    };
</script>
